
export const showLoadingMouse = (cursorType = 'show') => {
    const element = document.getElementById("cursor-loading");
    if (element) element.classList.add(cursorType)

    toggleMouseEvents(false);

    setTimeout(() => {
        hideLoadingMouse(cursorType)
    }, 8000);
}

export const hideLoadingMouse = (cursorType = 'show') => {
    const element = document.getElementById("cursor-loading");
    if (element) element.classList.remove(cursorType)

    toggleMouseEvents(true);
}

const toggleMouseEvents = (enable) => {
    const events = ["mousedown", "mouseup", "click", "mousemove"];
    const handler = enable ? "removeEventListener" : "addEventListener";

    events.forEach((event) => {
        window[handler](event, preventMouseEvent, true);
    });
};

const preventMouseEvent = (event) => {
    event.stopPropagation();
    event.preventDefault();
};